import CHEVRON_DOWN from "@/assets/icons/chevron-down.svg";
import "./style.scss";
import { FC, useState } from "react";
import { DropDownPropTypes, OptionItem } from "./model";
import OptionItemText from "./option-type/OptionItemText";
import OptionItemWithImage from "./option-type/OptionItemWithImage";

const Dropdown: FC<DropDownPropTypes> = ({
  value,
  options,
  placeHolder,
  disabled,
  onChange = () => {},
  width,
  optionType,
}) => {
  const [showOption, setShowOption] = useState<boolean>(false);

  function handleClick() {
    setShowOption(false);
    document.removeEventListener("click", handleClick);
  }

  const onClickDropDown = () => {
    if (!disabled) {
      if (!showOption) {
        setTimeout(() => {
          document.addEventListener("click", handleClick);
        }, 500);
      } else {
        document.removeEventListener("click", handleClick);
      }

      setShowOption(!showOption);
    }
  };

  const onClickOption = (optionItem: OptionItem) => {
    onChange(optionItem);
    setShowOption(false);
  };

  const dropDownGetClass = () => {
    let className = "input-box";
    if (showOption) {
      className += " option-is-opened";
    }
    if (disabled) {
      className += " disabled";
    }

    return className;
  };

  return (
    <div className="dropdown-component-wrapper">
      <div
        className={dropDownGetClass()}
        onClick={onClickDropDown}
        style={{ width: width ? width : "200px" }}
      >
        <label className={value?.label ? "" : "place-holder"}>
          {value?.label ? value.label : placeHolder}
        </label>
        <img src={CHEVRON_DOWN} alt="chevron-icon" />
      </div>

      {showOption && (
        <div className="option-list" style={{ width: width ? width : "200px" }}>
          {options.map((option, index) => (
            <span key={`${option}-${index}`}>
              {optionType === "product-option" && (
                <OptionItemWithImage
                  value={value}
                  option={option}
                  onClickOption={() => onClickOption(option)}
                />
              )}

              {optionType === "text-option" && (
                <OptionItemText
                  value={value}
                  option={option}
                  onClickOption={() => onClickOption(option)}
                />
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
